import React from 'react'
import { H1, H4, HEADING_TYPES } from 'components/Heading'

/**
 * The share banner component
 * @param {Map} props.staticText - The static text
 * @returns {JSX.Element} banner component
 */
function SharePageV3Banner (props) {
  const {
    staticText,
  } = props

  return (
    <div className="share-page-v3__banner">
      <div className="share-page-v3__banner-container">
        <H1 as={HEADING_TYPES.H2} className="share-page-v3__banner-title">{staticText.get('reasonTitle')}</H1>
        <p className="share-page-v3__banner-text">{staticText.get('reasonText')}</p>
        <H4 className="share-page-v3__banner-subtitle">{staticText.get('reasonSubTitle')}</H4>
      </div>
    </div>
  )
}

export default SharePageV3Banner
